"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Success = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var Success = function Success(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Success',
    viewBox: "0 0 320 250",
    __UIScope: "Success"
  }), react_1.default.createElement("rect", {
    width: "320",
    height: "198",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.75",
    rx: "12"
  }), react_1.default.createElement("g", {
    filter: "url(#Success__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "272",
    height: "198",
    x: "24",
    y: "24",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.THEME.PRIMARY,
    fillRule: "evenodd",
    d: "M42 187a10.002 10.002 0 0120 0c0 5.523-4.477 10-10 10s-10-4.477-10-10zm8.17 4.28l5.83-3.64a.76.76 0 000-1.28l-5.85-3.64a.75.75 0 00-1.15.63v7.3a.75.75 0 001.17.63z",
    clipRule: "evenodd"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "72",
    y: "172",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "152",
    y: "172",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "212",
    height: "8",
    x: "72",
    y: "194",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "258",
    height: "122",
    x: "31",
    y: "31",
    fill: ui_symbols_1.COLOR.BLUE[100],
    rx: "5"
  }), react_1.default.createElement("rect", {
    width: "258",
    height: "122",
    x: "31",
    y: "31",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "5"
  })), react_1.default.createElement("g", {
    filter: "url(#Success__filter1_d)"
  }, react_1.default.createElement("circle", {
    cx: "32",
    cy: "108",
    r: "24",
    fill: ui_symbols_1.COLOR.GREY.WHITE
  })), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREEN[400],
    fillRule: "evenodd",
    d: "M23.667 108a8.333 8.333 0 1116.667 0 8.333 8.333 0 01-16.667 0zm7.275 2.792l4.683-4.684a.417.417 0 000-.575l-.442-.441a.416.416 0 00-.583 0l-3.95 3.95-1.25-1.242a.398.398 0 00-.583 0l-.442.442a.415.415 0 000 .591l1.983 1.959a.402.402 0 00.584 0z",
    clipRule: "evenodd"
  }), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "Success__filter0_d",
    width: "296",
    height: "222",
    x: "16",
    y: "14",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4",
    dy: "2"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.24 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "Success__filter1_d",
    width: "72",
    height: "72",
    x: "0",
    y: "74",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4",
    dy: "2"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.87875 0 0 0 0 0.90142 0 0 0 0 0.95 0 0 0 0.24 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};

exports.Success = Success;